import { useEffect, useState } from "react"
import { Button, Spinner } from "react-bootstrap"
import Select from 'react-select'
import DataTable from "../../components/dataTable/DataTable"
import { createColumnHelper } from "@tanstack/react-table"
import dayjs from "dayjs"
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../config/apiClient"
import ModalQrCodesRelatorio from "./QrCodesModalRelatorio"

export default function QrCodesPage() {

    useEffect(() => {
        document.title = "QRCodes Ronda | OB PORTUS"

        carregarFiltros()
        // eslint-disable-next-line
    }, [])

    const [loading, setLoading] = useState<boolean>(false)
    const [showModalRelatorio, setShowModalDownloadRelatorio] = useState<boolean>(false)
    const [dados, setDados] = useState<any[]>([])

    const [empresasFiltro, setEmpresasFiltro] = useState<any>([])
    const [empresasFiltroSelected, setEmpresasFiltroSelected] = useState<any>([])

    const [centrosCustoFiltro, setCentrosCustoFiltro] = useState<any[]>([])
    const [centrosCustoFiltroSelected, setCentrosCustoFiltroSelected] = useState<any[]>([])
    
    const [situacaoFiltro, setSituacaoFiltro] = useState<any[]>([
        {
            "value": `0`,
            "label": `Ativo`
        },
        {
            "value": `1`,
            "label": `Inativo`
        }
    ])
    const [situacaoFiltroSelected, setSituacaoSelected] = useState<any[]>([
        {
            "value": `0`,
            "label": `Ativo`
        }
    ])

    async function carregarFiltros() {
        setLoading(true)
        setSituacaoFiltro([
            {
                "value": `0`,
                "label": `Ativo`
            },
            {
                "value": `1`,
                "label": `Inativo`
            }
        ])
        const api = await reqGetNew(ApiEndpoints.qrcodeFiltros)
        if (api.status === 200) {
            const dados = api.data
            let empresasAux = dados.empresas.map((item:any, index:any) => (
                {
                    "value": `${item.codigo}`,
                    "label": `${item.codigo} - ${item.nome}`
                }
            ))
            setEmpresasFiltro(empresasAux)
            let centrosAux = dados.centros_custo.map((item:any, index:any) => (
                {
                    "value": `${item.codigo}`,
                    "label": `${item.codigo} - ${item.centro_custo}`
                }
            ))
            setCentrosCustoFiltro(centrosAux)
        }

        await listarRegistros()

        setLoading(false)
    }

    async function listarRegistros() {

        const filtro = {
            id_empresa: empresasFiltroSelected.map((item:any, index:any) => (Number(item.value))),
            id_centro_custo: centrosCustoFiltroSelected.map((item:any, index:any) => (Number(item.value))),
            situacao: situacaoFiltroSelected.map((item:any, index:any) => (Number(item.value))),
        }

        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.qrcodeListar, filtro)
        
        if (api.status === 200) {
            setDados(api.data)
        }
        
        setLoading(false)
    }

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg:any = dados[idx]
        const link = `/qrcode/editar?id=${reg.id_qrcode}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg:any = dados[idx]
        const link = `/qrcode/editar?id=${reg.id_qrcode}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">
            <ModalQrCodesRelatorio show={showModalRelatorio} handleClose={() => {setShowModalDownloadRelatorio(false)}} />
            
            <div className="div-row-space-between">
                <h1 id="titleMain">QRCodes Ronda</h1>
                <div className="div-row">
                    <Button variant="secondary" onClick={() => { setShowModalDownloadRelatorio(true) }} style={{marginRight: "10px"}}>Download Relatório</Button>
                    <Button onClick={() => {window.location.assign(`/qrcode/cadastrar`)}} >Cadastrar</Button>
                </div>
            </div>

            <br></br>

            <div className="div-row">
                <Select name='ids_empresas' id='ids_empresas' options={empresasFiltro} defaultValue={empresasFiltroSelected} placeholder="Empresas" isMulti closeMenuOnSelect={false} onChange={
                    (choice) => {
                        setEmpresasFiltroSelected(choice)
                    }
                } styles={styleSelectEmpresas} />
                <Select name='ids_centro_custo' id='ids_centro_custo' options={centrosCustoFiltro} defaultValue={centrosCustoFiltroSelected} value={centrosCustoFiltroSelected} placeholder="Centros de Custo" isMulti closeMenuOnSelect={false} onChange={
                    (choice:any) => {
                        setCentrosCustoFiltroSelected(choice)
                    }
                } styles={styleSelectCentros} />
                <Select name='ids_inativado' id='ids_inativado' options={situacaoFiltro} defaultValue={situacaoFiltroSelected} value={situacaoFiltroSelected} placeholder="Situação" isMulti closeMenuOnSelect={false} onChange={
                    (choice:any) => {
                        setSituacaoSelected(choice)
                    }
                } styles={styleSelectEmpresas} />
                <Button onClick={() => { listarRegistros() }} variant='primary' style={{height: '40px'}} className='div-row-space-between'>Filtrar <span className="material-symbols-outlined">filter_alt</span></Button>
            </div>

            <br></br>

            {loading && <Spinner />}
            {!loading && <DataTable dados={dados} tableSize={'fixed'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} defaultRows={20} />}

        </div>
    )
}

const columnHelper = createColumnHelper<any>()

const defaultColumns = [
    columnHelper.accessor(row => `${dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm:ss")}`, {
        header: 'Criado em'
    }),
    columnHelper.accessor(row => `#${row.id_qrcode} | ${row.descricao}`, {
        header: 'QRCode',
        size: 500,
    }),
    columnHelper.accessor(row => row.id_empresa.nome, {
        header: 'Empresa',
        size: 300,
    }),
    columnHelper.accessor(row => row.obs, {
        header: 'Observação',
        size: 300,
    }),
    columnHelper.accessor(row => `${row.id_centro_custo.codigo} - ${row.id_centro_custo.centro_custo}`, {
        header: 'Centro de Custo',
        size: 400,
    }),
    columnHelper.accessor(row => row.inativo === 1 ? "Inativo" : "Ativo", {
        header: 'Situação',
        size: 100,
    }),
    columnHelper.accessor(row => row.nfc_tag_id === null ? "Inativo" : "Ativo", {
        header: 'NFC Ativo',
        size: 100,
    }),
    columnHelper.accessor(row => `${row.latitude}, ${row.longitude}`, {
        header: 'Lat/Long',
        size: 300,
    }),
]

const defaultOrder:any[] = []

const styleSelectEmpresas = {
    control: (baseStyles:any, state:any) => ({
        ...baseStyles,
        width: '250px',
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    input: (provided:any, state:any) => ({
        ...provided,
        margin: '0px',
        fontSize: '14px'
    }),
    indicatorSeparator: (state:any) => ({
        display: 'none',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided:any, state:any) => ({
        ...provided,
        fontSize: '14px'
    }),
}

const styleSelectCentros = {
    control: (baseStyles:any, state:any) => ({
        ...baseStyles,
        width: '400px',
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    input: (provided:any, state:any) => ({
        ...provided,
        margin: '0px',
        fontSize: '14px'
    }),
    indicatorSeparator: (state:any) => ({
        display: 'none',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided:any, state:any) => ({
        ...provided,
        fontSize: '14px'
    }),
}
